'use client';

import { XMarkIcon } from '@heroicons/react/20/solid';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $patchStyleText } from '@lexical/selection';
import { $getRoot, $getSelection, $isRangeSelection } from 'lexical';

export function ClearFormattingButton({ onMarkdownSync }) {
    const [editor] = useLexicalComposerContext();

    const expandSelectionToAllIfNone = () => {
        let sel = $getSelection();
        if (!$isRangeSelection(sel) || sel.isCollapsed()) {
            const root = $getRoot();
            root.select(0, root.getTextContentSize());
            sel = $getSelection();
        }
        return sel && $isRangeSelection(sel) ? sel : null;
    };

    const clearFormatting = () => {
        editor.update(() => {
            const sel = expandSelectionToAllIfNone();
            if (!sel) return;

            // 1) Remove inline color/gradient styles applied by TextColorButton
            $patchStyleText(sel, {
                'background-image': null,
                '-webkit-background-clip': null,
                'background-clip': null,
                color: null,
                'font-family': null,
            });

            // 2) Clear text format bits (bold/italic/underline/etc.) on text nodes
            const nodes = sel.getNodes();
            for (const n of nodes) {
                if (typeof n.setFormat === 'function') {
                    // 0 clears all format flags (bold, italic, underline, etc.)
                    n.setFormat(0);
                }
            }
            // Note: We intentionally DO NOT unwrap or modify LinkNodes,
            // so links remain intact.
        });
    };

    return (
        <button
            type="button"
            className="mdx-btn"
            title="Clear formatting (keep links)"
            aria-label="Clear formatting (keep links)"
            onMouseDown={(e) => {
                e.preventDefault(); // keep selection stable
                clearFormatting();
                onMarkdownSync?.();
            }}
        >
            <XMarkIcon className="h-[14px] w-[14px]" aria-hidden="true" />
        </button>
    );
}
